import React from 'react'
import PropTypes from 'prop-types'
import { TooltipOnHover } from 'components/Utils/TooltipOnHover'
import classNames from 'classnames'

export default function ApplicationIconHolder({
  id,
  onClick = () => {},
  children = () => null,
  tooltipContent = 'Share',
  className = '',
}) {
  return (
    <TooltipOnHover id={id} placement="top" tooltipContent={tooltipContent}>
      <div
        onClick={onClick}
        className={classNames(
          className,
          'background-shade-100 radius-normal padding-normal flexbox flexbox-align-center shadow--small shade-30 shade-20-on-hover pointer shadow-on-hover'
        )}
      >
        {children}
      </div>
    </TooltipOnHover>
  )
}

ApplicationIconHolder.propTypes = {
  id: PropTypes.string.isRequired,
  tooltipContent: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
}
